function capitalizeFirstLetter(value: string) {
  return String(value).charAt(0).toUpperCase() + String(value).slice(1)
}

export function usePortalStage() {
  return import.meta.env.VITE_STAGE === "production"
    ? null
    : capitalizeFirstLetter(import.meta.env.VITE_STAGE)
}
